module.exports = __webpack_public_path__ + "static/media/img3-1.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/nutricheck_foliar/N/img3-1.png
// module id = 2161
// module chunks = 3